import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-mb-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-key" }, null, -1)
const _hoisted_5 = { class: "p-d-flex p-jc-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VInputText = _resolveComponent("VInputText")!
  const _component_VDropdown = _resolveComponent("VDropdown")!
  const _component_VInputSwitch = _resolveComponent("VInputSwitch")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Password = _resolveComponent("Password")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createBlock(_component_PDialog, {
    minX: 0,
    minY: 0,
    style: {width: '450px'},
    class: "p-fluid",
    draggable: "",
    keepInViewPort: "",
    modal: "",
    onHide: _ctx.onHide,
    onShow: _ctx.onShow
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.user?.id
              ? _ctx.$t('entity.user_dialog.edit')
              : _ctx.$t('entity.user_dialog.new')), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          label: _ctx.$t('cancel'),
          class: "p-button-secondary",
          icon: "pi pi-times",
          onClick: _ctx.hide
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.user?.id ? _ctx.$t('common.save') : _ctx.$t('add'),
          loading: _ctx.isLoading,
          icon: "pi pi-check",
          type: "submit",
          form: "user-form"
        }, null, 8, ["label", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        id: "user-form",
        onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
      }, [
        _createVNode(_component_Fieldset, { class: "p-fluid" }, {
          legend: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_VInputText, { field: "id" }, null, 512), [
              [_vShow, false]
            ]),
            _createVNode(_component_VInputText, {
              label: _ctx.$t('user.name'),
              field: "name"
            }, null, 8, ["label"]),
            _createVNode(_component_VInputText, {
              label: _ctx.$t('user.surname'),
              field: "surname"
            }, null, 8, ["label"]),
            _createVNode(_component_VInputText, {
              label: _ctx.$t('user.email'),
              field: "email"
            }, null, 8, ["label"]),
            (_ctx.roleOptions?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_VDropdown, {
                    id: "role-dropdown",
                    modelValue: _ctx.values.role,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.values.role = $event)),
                    label: _ctx.$t('user.role'),
                    options: _ctx.roleOptions,
                    autocomplete: "nope",
                    name: "role"
                  }, null, 8, ["modelValue", "label", "options"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_VInputSwitch, {
              labelOff: _ctx.$t('user.inactive'),
              labelOn: _ctx.$t('user.active') ,
              name: "is_active"
            }, null, 8, ["labelOff", "labelOn"])
          ]),
          _: 1
        }),
        _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
          legend: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createVNode(_component_FloatLabel, {
              label: _ctx.$t('user.password') + ' *'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Password, {
                  modelValue: _ctx.pwd,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pwd = $event)),
                  class: _normalizeClass({ 'p-invalid' : (_ctx.pwdTouched && _ctx.pwdErrors?.length > 0) }),
                  feedback: false,
                  toggleMask: ""
                }, null, 8, ["modelValue", "class"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.pwdTouched)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.pwdErrors, (e) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: `pwd_${e}`,
                    class: "p-error"
                  }, _toDisplayString(_ctx.$t(e)), 1))
                }), 128))
              : _createCommentVNode("", true),
            _createVNode(_component_FloatLabel, {
              label: _ctx.$t('user.confirm_password') + ' *',
              class: "p-mt-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Password, {
                  modelValue: _ctx.cpwd,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.cpwd = $event)),
                  class: _normalizeClass({ 'p-invalid' :(_ctx.cpwdTouched && _ctx.cpwdErrors?.length > 0)  }),
                  feedback: false,
                  toggleMask: ""
                }, null, 8, ["modelValue", "class"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.cpwdTouched)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.cpwdErrors, (e) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: `cpwd_${e}`,
                    class: "p-error"
                  }, _toDisplayString(_ctx.$t(e)), 1))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }, 8, ["onHide", "onShow"]))
}